// Location: Corporate-dashboard/Container/components/dashboard/LocationAnalysis.js

import React, { useState, useRef } from 'react';
import { Card, Row, Col, Typography, Spin } from 'antd';
import { useSelector } from 'react-redux';

// Import the sub-components
import HorizontalBar from './HorizontalBar';
import BarGender from './BarGender';

const { Title, Text } = Typography;
const LocationAnalysis = ({ locationChartData, selectedFilter, onLocationTypeChange, onToggleChange, topLocationsRef, setIndividualExportLoading, setExportMessage }) => {
  const locationChartLoading = useSelector(state => state?.corporateDashboardPage2?.locationChartLoading);
  const [selectedLocation, setSelectedLocation] = useState('');
  const [isPermanentLocation, setIsPermanentLocation] = useState(false);
  const locationChartRef = useRef();

  const handleLocationClick = (event, element) => {
    if (element && element.length > 0) {
      const { index } = element[0];
      const locationBarData = locationChartData?.locationBarChart || [];
      const validLocations = locationBarData.filter(item => (item.location || "Unknown") !== "");
      const labels = validLocations.map(item => item.location || "Unknown");
      const location = labels[index];
      setSelectedLocation(location);
      
      // Call parent's click handler if provided
      if (onLocationClick) {
        onLocationClick(event, element);
      }
    }
  };

  const handleClearLocation = () => {
    setSelectedLocation('');
  };

  const handleToggleWithClear = (showCities) => {
    // Clear selected location when toggle changes
    handleClearLocation();
    // Call the parent's toggle handler
    if (onToggleChange) {
      onToggleChange(showCities);
    }
  };

  const handleLocationTypeChangeWithClear = (isPermanent) => {
    // Clear selected location when location type changes
    handleClearLocation();
    // Update local state
    setIsPermanentLocation(isPermanent);
    // Call the parent's location type change handler
    if (onLocationTypeChange) {
      onLocationTypeChange(isPermanent);
    }
  };

  return (
    // This Card contains both charts
    <Card className="cd-card" bordered={true} style={{ width: '100%', height: '100%' }} bodyStyle={{ padding: '24px', height: '100%', display: 'flex', flexDirection: 'column' }}>
      <style>{`
        .full-height-spin-wrapper {
          height: 100%;
          display: flex;
          flex-direction: column;
        }
        .full-height-spin-wrapper .ant-spin-blur {
          opacity: 0.5;
          user-select: none;
        }
        .full-height-spin-wrapper .ant-spin-container {
          height: 100%;
          display: flex;
          flex-direction: column;
        }
      `}</style>
      <Spin spinning={locationChartLoading} wrapperClassName="full-height-spin-wrapper">
        {/* This Row splits the Card into two columns */}
        <Row gutter={[24, 24]} style={{ flexGrow: 1, minHeight: 0 }}>
          
          {/* Column 1: Location Bar Chart */}
          <Col xs={24} lg={12}>
            <HorizontalBar
              locationChartRef={locationChartRef}
              locationChartData={locationChartData}
              selectedFilter={selectedFilter}
              selectedLocation={selectedLocation}
              onLocationClick={(event, elements) => {
                if (elements && elements.length > 0) {
                  const locationBarData = locationChartData?.locationBarChart || [];
                  const validLocations = locationBarData.filter(item => (item.location || "Unknown") !== "");
                  const labels = validLocations.map(item => item.location || "Unknown");
                  const selectedLocation = labels[elements[0].index];
                  setSelectedLocation(selectedLocation);
                }
              }}
              onClearSelection={handleClearLocation}
              onLocationTypeChange={handleLocationTypeChangeWithClear}
              onToggleChange={handleToggleWithClear}
            />
          </Col>

          {/* Column 2: Gender Donut Chart */}
          <Col xs={24} lg={12}>
            <BarGender
              key={`gender-${selectedLocation}-${locationChartData?.locationBarChart?.length || 0}`}
              location={selectedLocation}
              locationGenderData={locationChartData?.locationBarChart || []}
              topLocationsRef={topLocationsRef}
              setIndividualExportLoading={setIndividualExportLoading}
              setExportMessage={setExportMessage}
              isPermanentLocation={isPermanentLocation}
            />
          </Col>
        </Row>
      </Spin>
    </Card>
  );
};

export default LocationAnalysis;
